import styled, { css } from 'styled-components';
import { Container as C } from 'react-bootstrap';

export const Body = styled.div<{
  $isCompact: boolean;
}>`
  position: fixed;
  top: 0;
  left: 0;
  right: var(--occurrence-error-sidebar-offset, 0px);
  z-index: 5;
  padding: ${props =>
    props.$isCompact ? props.theme.spacing.sm : props.theme.spacing.md};
  transition: padding 200ms ease, right 200ms ease;
`;

export const Container = styled(C)<{
  $isCompact: boolean;
  $withSidebar?: boolean;
}>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: ${props => (props.$isCompact ? 'center' : 'stretch')};
  gap: ${props => (props.$isCompact ? props.theme.spacing.md : '0')};

  min-width: ${props => (props.$withSidebar ? '100%' : '80%')} !important;
  width: 100%;
  margin: 0 auto;

  padding: ${props => (props.$isCompact ? props.theme.spacing.sm : '0')};
  border-radius: 6px;
  min-height: ${props => (props.$isCompact ? 'auto' : '210px')};
  max-height: ${props => (props.$isCompact ? 'none' : '250px')};

  background-color: ${props => props.theme.colors.white};
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.06);
  transition: min-height 200ms ease, max-height 200ms ease;

  ${props =>
    props.$withSidebar &&
    css`
      margin: 0;
      max-width: none;
    `}
`;

export const GeneralInfoSection = styled.div`
  flex: 1;
  max-width: 25%;
  border-right: 1px solid #ebe9f1;
`;

export const GeneralInfoHeader = styled.header<{
  withShot: boolean;
}>`
  height: 43px;
  display: flex;
  align-items: center;
  padding: 16px 20px;
  background-color: ${props =>
    props.withShot ? '#ea5455' : props.theme.colors.tertiary};
  color: ${props => props.theme.colors.white};

  > b {
    margin-left: 8px;
    color: ${props => props.theme.colors.white};
    font-size: 12px;
    line-height: 23px;
  }

  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 23px;
`;

export const GeneralInfoContainer = styled.div`
  padding: 16px 16px;
`;

export const GeneralInfoDateContainer = styled.div`
  display: flex;
`;

export const GeneralInfoDateStatusText = styled.p<{
  withShot: boolean;
}>`
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
  color: ${props => (props.withShot ? '#ea5455' : '')};
  margin: 0 !important;
`;

const InfoText = styled.p`
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 21px;
  margin: 0 !important;
  padding: 0 !important;
  color: #5e5873;
`;

export const GeneralInfoDateText = styled(InfoText)``;

export const GeneralInfoAddressContainer = styled.div`
  display: flex;
`;

export const GeneralInfoAddressText = styled(InfoText)``;

export const DataSection = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 16px 32px;
`;

export const DataOccurrenceNumber = styled.p`
  font-style: normal;
  font-weight: bold;
  padding: 0 16px;
`;

export const DataItemsContainer = styled.div`
  display: flex;
  flex-direction: row;
  word-break: break-all;
  overflow: auto;
`;

export const DataItemsWoundedAndDeadContainer = styled.div`
  display: flex;
  padding: 0 16px;
  flex-direction: column;
`;

export const DataItemContainer = styled.div``;

export const DataItemTitle = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 23px;
  color: #5e5873;
`;

export const DataItemInfoText = styled.p`
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 18px;
  opacity: 0.6;
  margin: 0 !important;
`;

export const ActionsSection = styled.div<{
  newOccurrence: boolean;
}>`
  display: flex;
  flex-direction: column;
  justify-content: ${props =>
    props.newOccurrence ? 'flex-end' : 'space-between'};

  align-items: flex-end;

  padding: 16px 16px;
`;

export const OccurrenceDateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

export const OccurrenceDateInfo = styled.p`
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 18px;
  opacity: 0.6;
  margin: 0 !important;
`;

export const ButtonsContainer = styled.div`
  min-width: 220px;
  display: flex;
  flex-direction: column;
`;

export const ConfirmButton = styled.button<{
  newOccurrence: boolean;
  $compact?: boolean;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${props =>
    props.$compact
      ? `calc(${props.theme.spacing.xl} + ${props.theme.spacing.xs})`
      : '42px'};
  width: ${props => (props.$compact ? 'auto' : '100%')};

  padding: ${props =>
    props.$compact
      ? `${props.theme.spacing.xs} ${props.theme.spacing.md}`
      : '12px 38px'};
  border-radius: 6px;

  color: ${props => props.theme.colors.white};
  background: ${props =>
    props.newOccurrence
      ? 'linear-gradient(90deg, #f83600, #fe8c00)'
      : props.theme.colors.success};
  border: none;

  &:hover {
    background: ${props =>
      props.newOccurrence
        ? 'linear-gradient(90deg, #e53c0d, #e53c0d)'
        : '#27b263'};

    transition: background-color 200ms linear;
  }

  & > div {
    margin-right: 8px;
    color: white;
  }
`;

export const BackButton = styled.button<{
  $compact?: boolean;
}>`
  height: ${props =>
    props.$compact
      ? `calc(${props.theme.spacing.xl} + ${props.theme.spacing.xs})`
      : '42px'};
  width: ${props => (props.$compact ? 'auto' : '100%')};

  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${props =>
    props.$compact
      ? `${props.theme.spacing.xs} ${props.theme.spacing.md}`
      : '12px 38px'};
  border-radius: 6px;
  color: ${props => props.theme.colors.black};
  background: transparent;
  border: 1px solid #2c3941;

  &:hover {
    background: #f2f2f2;
    transition: background-color 200ms linear;
  }

  > img {
    margin-right: ${props => props.theme.spacing.sm};
  }
`;

export const ClearButton = styled(BackButton)``;

export const CompactInfoRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.md};
  width: 100%;
`;

export const CompactStatusPill = styled.span<{
  $withShot: boolean;
}>`
  display: inline-flex;
  align-items: center;
  padding: ${props => props.theme.spacing.xxs}
    ${props => props.theme.spacing.xs};
  border-radius: ${props => props.theme.radii.pill};
  font-size: ${props => props.theme.typography.sizes.xs};
  line-height: ${props => props.theme.typography.lineHeights.xs};
  font-weight: ${props => props.theme.typography.weights.semibold};
  color: ${props => props.theme.colors.white};
  background-color: ${props =>
    props.$withShot ? props.theme.colors.danger : props.theme.colors.tertiary};
  flex-shrink: 0;
`;

export const CompactInfoText = styled.p`
  flex: 1;
  min-width: 0;
  margin: 0;
  font-size: ${props => props.theme.typography.sizes.sm};
  line-height: ${props => props.theme.typography.lineHeights.sm};
  font-weight: ${props => props.theme.typography.weights.medium};
  color: ${props => props.theme.colors.textSecondary};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const CompactButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.xs};
  flex-shrink: 0;
`;
